import { useState, useEffect, useRef } from "react";
import "./quickButton.scss";

import { isExternalUrl, HOSTNAME } from "@src/utils";

import { Icon } from "@src/shared/src";
import QuickButtonIcon from "@src/assets/images/icon/ic-smile.png";
import ReservationIcon from "@src/assets/images/icon/ic-reservation.png";
import RecommendIcon from "@src/assets/images/icon/ic-recommend.png";
import ContactIcon from "@src/assets/images/icon/ic-contact.png";

const WEDDINGHALL_QUICK_MODAL_MENUS = [
  {
    id: 1,
    title: "방문 예약",
    url: `${HOSTNAME}/booking/hall?inpath=ETC&origin=portal&hidetop=true`,
    iconUrl: ReservationIcon,
    backgroundColor: "#2CAD5A",
    additionalClassName: "first",
  },
  {
    id: 2,
    title: "맞춤 추천",
    url: `${HOSTNAME}/recommend/hall/start?inpath=CHAT&origin=chat`,
    iconUrl: RecommendIcon,
    backgroundColor: "#3B6AE3",
    additionalClassName: "second",
  },
  {
    id: 3,
    title: "문의 내역",
    url: `${HOSTNAME}/booking/management/list`,
    iconUrl: ContactIcon,
    backgroundColor: "#7D4EE7",
    additionalClassName: "third",
  },
];

// 추후 확장한다면 quick-button-modal에 들어가 버튼들을 props로 받아야 할듯?
// 아니면 state들을 호출하는 쪽에서 관리해야 할수도

// 추가로, ScrollTopButton 컴포넌트와 위치가 겹치는 페이지가 있어서
// 이 컴포넌트는 단독으로 사용하지 않고, AppQuickButtonContainer에 담아서 한곳에서 사용해야겠다.
export default function QuickButtonWrapper(props: {
  text: string;
  buttonWidth: number;
  customOnClick?: () => void;
}) {
  const [isFontLoaded, setIsFontLoaded] = useState<boolean>(false);

  // 폰트 로드 완료 후 버튼 렌더링 (정확한 방법은 아님)
  useEffect(() => {
    setTimeout(() => {
      setIsFontLoaded(true);
    }, 500);
  }, []);

  return <>{isFontLoaded === true && <QuickButton {...props} />}</>;
}

function QuickButton(props: { text: string; buttonWidth: number; customOnClick?: () => void }) {
  const isModalOpenRef = useRef<boolean>(false);

  const [isButtonMinimized, setIsButtonMinimized] = useState<boolean | null>(null);
  const [isQuickButtonModalOpen, setIsQuickButtonModalOpen] = useState(false);
  const [isModalAnimating, setIsModalAnimating] = useState(false);

  useEffect(() => {
    function handleScroll() {
      const isScrollTop = window.scrollY === 0;
      if (isModalOpenRef.current === false) {
        setIsButtonMinimized(!isScrollTop);
      }
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function handleClickQuickButton() {
    // 커스텀 클릭 이벤트가 있으면 실행
    if (props.customOnClick) {
      props.customOnClick();
      return;
    }

    // 모달이 닫혀있으면 모달 열기 + 버튼 최소화
    if (isQuickButtonModalOpen === false) {
      setIsButtonMinimized(true);
      setIsQuickButtonModalOpen(true);
      isModalOpenRef.current = true;
      return;
    }

    // 모달이 열려있으면 모달 닫기 + 애니메이션 + 버튼 조정
    closeModal();
  }

  // 모달닫기 + 애니메이션 + 버튼 조정
  function closeModal() {
    setIsModalAnimating(true);

    setTimeout(() => {
      setIsQuickButtonModalOpen(false);
      isModalOpenRef.current = false;
      setIsModalAnimating(false);

      const isScrollTop = window.scrollY === 0;
      setIsButtonMinimized(!isScrollTop);
    }, 300); // 애니메이션 시간과 동일하게 설정
  }

  return (
    <>
      <div className="quick-button-component" style={{ width: props.buttonWidth }}>
        <button
          onClick={handleClickQuickButton}
          className={`
            quick-button
            ${isButtonMinimized === true ? "minimized" : ""}
            ${isButtonMinimized === false ? "no-minimized" : ""}
            ${isQuickButtonModalOpen === true ? "modal-open" : "modal-close"}
          `}
        >
          <div className="icon-box">
            {isQuickButtonModalOpen === true ? (
              <Icon name="XG900" size={24} color="#fff" />
            ) : (
              <img src={QuickButtonIcon} alt="" />
            )}
          </div>
          <p className="text">{props.text}</p>
        </button>
      </div>

      <div
        onClick={closeModal}
        className={`
          quick-button-modal-component
          ${isQuickButtonModalOpen === true ? "open" : ""}
        `}
      >
        {WEDDINGHALL_QUICK_MODAL_MENUS.map((menu, index) => (
          <button
            key={menu.id}
            className={`
              action-button
              ${menu.additionalClassName}
              ${isModalAnimating === true ? "animating-out" : "animating-in"}
            `}
            onClick={(e) => {
              e.stopPropagation();
              window.location.href = isExternalUrl(menu.url);
              closeModal();
            }}
          >
            <p className="text">{menu.title}</p>
            <div className="icon-box" style={{ backgroundColor: menu.backgroundColor }}>
              <img src={menu.iconUrl} alt="" />
            </div>
          </button>
        ))}
      </div>
    </>
  );
}
